import React, { useState, useEffect } from 'react';
import ReviewCard from '../components/ReviewCard';
import Loader from '../components/Loader';
import { fetchReviewsByIds } from '../api';

export default function QuestionReviewsPage({ question, user, setView }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!question?.reviewIds?.length) { setLoading(false); return; }
    fetchReviewsByIds(question.reviewIds)
      .then(data => setReviews(data.reviews || []))
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  }, [question]);

  if (!question) return null;

  return (
    <div style={{ animation: 'fadeUp 0.35s ease-out' }}>
      {/* Back button */}
      <button
        onClick={() => setView('top-questions')}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          background: 'none', border: '1px solid var(--border)',
          borderRadius: 8, padding: '6px 12px', marginBottom: 16,
          fontSize: 13, fontWeight: 600, color: 'var(--text2)',
          cursor: 'pointer', fontFamily: 'var(--sans)', transition: 'all 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = '#7c3aed'; e.currentTarget.style.color = '#7c3aed'; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text2)'; }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="m15 18-6-6 6-6" />
        </svg>
        Top Questions
      </button>

      {/* Question header */}
      <div style={{
        background: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
        padding: '20px 24px', borderRadius: 12, color: '#fff',
        boxShadow: '0 8px 16px -4px rgba(124,58,237,0.3)',
        marginBottom: 20, position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', right: -10, top: -20, fontSize: 80, opacity: 0.08 }}>💬</div>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1.2, opacity: 0.8, marginBottom: 8 }}>
          Interview Question
        </div>
        <div style={{ fontSize: 16, fontWeight: 700, lineHeight: 1.5, marginBottom: 12 }}>
          "{question.question}"
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 12, fontWeight: 600, background: 'rgba(255,255,255,0.2)', padding: '3px 10px', borderRadius: 20 }}>
            {question.count} {question.count === 1 ? 'kahani' : 'kahanis'}
          </span>
          {question.companies?.slice(0, 3).map(c => (
            <span key={c} style={{ fontSize: 12, fontWeight: 500, background: 'rgba(255,255,255,0.15)', padding: '3px 10px', borderRadius: 20 }}>
              {c}
            </span>
          ))}
        </div>
      </div>

      {/* Reviews */}
      {loading ? (
        <Loader inline message="Loading relevant kahanis…" />
      ) : reviews.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--text3)', fontSize: 14 }}>
          No kahanis found for this question.
        </div>
      ) : (
        <>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12, fontWeight: 500 }}>
            {reviews.length} {reviews.length === 1 ? 'kahani' : 'kahanis'} with this question
          </div>
          {reviews.map((r, i) => (
            <ReviewCard key={r.id || r._id || i} review={r} delay={i * 0.05} currentUser={user} />
          ))}
        </>
      )}
    </div>
  );
}
